import { IconButton, ListItemAvatar, ListItemText } from "@mui/material";
import {
  Maybe,
  useRejectSuggestedSearchMutation,
  UserRecentSearchElementType,
  UserRecentSearchInput,
  UserSuggestedSearchOutput
} from "api";
import { AddRemoveSavedSearchButton } from "components/Buttons";
import CombinationSearchAvatar from "components/CombinationSearchAvatar";
import CombinationSearchLink from "components/CombinationSearchLink";
import CombinationSearchSubTitle from "components/CombinationSearchSubTitle";
import CombinationSearchTitle from "components/CombinationSearchTitle";
import CloseIcon from "@mui/icons-material/Close";
import { FC, useCallback, useMemo } from "react";

interface SugestedSearchCardProps {
  searchItem: Maybe<UserSuggestedSearchOutput> | undefined;
}

export const SugestedSearchCard: FC<SugestedSearchCardProps> = ({
  searchItem,
}) => {
  const [firstElement, ...restElement] = [
    searchItem?.User,
    searchItem?.Dollartag,
    searchItem?.Hashtag,
    searchItem?.Club,
  ].filter(Boolean);

  const [removeSuggestedSearch] = useRejectSuggestedSearchMutation();

  const inputForAdd = useMemo(() => {
    const input: Maybe<
      Maybe<UserRecentSearchInput> | Maybe<UserRecentSearchInput>[]
    > = [];
    if (searchItem?.User?.id) {
      input.push({
        searchElementId: searchItem?.User?.id,
        searchElementType: UserRecentSearchElementType.User,
      });
    }
    if (searchItem?.Club?.clubId) {
      input.push({
        searchElementId: searchItem?.Club?.clubId,
        searchElementType: UserRecentSearchElementType.Club,
      });
    }
    if (searchItem?.Dollartag?.dollarTagId) {
      input.push({
        searchElementId: searchItem?.Dollartag?.dollarTagId?.toString(),
        searchElementType: UserRecentSearchElementType.DollarTag,
      });
    }
    if (searchItem?.Hashtag?.TagId) {
      input.push({
        searchElementId: searchItem?.Hashtag?.TagId,
        searchElementType: UserRecentSearchElementType.HashTag,
      });
    }

    return input;
  }, [searchItem]);

  const handleRemoveRecentSearch = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      e.stopPropagation();
      const searchId = searchItem?.searchId;
      removeSuggestedSearch({
        variables: {
          searchId,
        },
        update: (cache) => {
          cache.evict({
            id: cache.identify({
              searchId,
              __typename: "UserSuggestedSearchOutput"
            })
          })
          cache.gc()
        },
      });
    },
    [searchItem, removeSuggestedSearch]
  );

  return (
    <CombinationSearchLink
      dense
      data={[firstElement, ...restElement]}
    >
      <ListItemAvatar>
        <CombinationSearchAvatar data={firstElement} />
      </ListItemAvatar>
      <ListItemText
        disableTypography
        primary={<CombinationSearchTitle data={firstElement} />}
        secondary={
          <CombinationSearchSubTitle data={[firstElement, ...restElement]} />
        }
      />
      <AddRemoveSavedSearchButton
        searchId={searchItem?.searchId}
        isSaved={false}
        inputForAdd={inputForAdd}
      />

      <IconButton
        sx={{ width: "40px", height: "40px", marginLeft: "auto" }}
        onClick={handleRemoveRecentSearch}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

    </CombinationSearchLink>
  );
};
